import { notify } from "@kyvg/vue3-notification";

export default function (type: any, data: any) {
  let message = ''
  if (typeof data === 'string') {
    message = data
  } else if (data instanceof Array) {
    message = data.join('<br>')
  } else if (data && typeof data === 'object') {
    let msgArray: any[] = []
    for (let i = 0; i < Object.keys(data).length; i++) {
      let key = Object.keys(data)[i]
      msgArray = msgArray.concat(data[key])
    }
    message = msgArray.join('<br>')
  } else if (data) {
    message = data
  }
  notify({
    type: type,
    text: message
  })
}